import type { ReactNode } from 'react'

interface PageHeaderProps {
  title: string
  description?: ReactNode
  action?: ReactNode
  className?: string
  /** Dar ekranda aksiyonu başlığın altına tam genişlikte alır. */
  stackOnMobile?: boolean
  /** Ana sayfa kategori blokları ile aynı kalın başlık */
  variant?: 'default' | 'category'
}

/** Liste sayfaları için ortak, mobilde sıkı başlık */
export default function PageHeader({
  title,
  description,
  action,
  className = '',
  stackOnMobile = false,
  variant = 'default',
}: PageHeaderProps) {
  const titleClassName =
    variant === 'category'
      ? 'truncate text-[clamp(1.25rem,1.1rem+0.75vw,1.625rem)] font-black tracking-tight text-gray-900 dark:text-gray-100'
      : 'page-title break-words text-gray-900 dark:text-white'

  return (
    <header
      className={`mb-4 flex min-w-0 items-center justify-between gap-3 sm:mb-6 ${stackOnMobile ? 'max-sm:flex-col max-sm:items-stretch max-sm:gap-2' : ''} ${className}`}
    >
      <div className="min-w-0 flex-1">
        <h1 className={titleClassName}>{title}</h1>
        {description ? (
          <div className="mt-0.5 text-xs leading-snug text-gray-500 dark:text-gray-400 sm:mt-1 sm:text-sm">
            {description}
          </div>
        ) : null}
      </div>
      {action ? (
        <div
          className={`shrink-0 self-start pt-0.5 sm:self-center sm:pt-0 ${stackOnMobile ? 'max-sm:w-full max-sm:self-stretch max-sm:pt-0' : ''}`}
        >
          {action}
        </div>
      ) : null}
    </header>
  )
}
